'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What does your website support and maintenance service include?",
    answer: "Our service covers regular updates, performance optimization, bug fixes, security patches, content changes, backups, and 24/7 monitoring to keep your website running smoothly and securely."
  },
  {
    question: "Why is ongoing website maintenance important?",
    answer: "Without regular maintenance, websites become vulnerable to security threats, performance issues, and outdated content. Maintenance ensures your site stays fast, secure, and compatible with the latest browsers and devices."
  },
  {
    question: "What is the average website maintenance cost for a business website?",
    answer: "The website maintenance cost depends on factors like website size, features, hosting, security, updates, and technical support. On average, small business websites may require basic maintenance costing a few thousand rupees per month, while larger eCommerce or corporate websites may need advanced support packages. Regular updates, backups, and performance monitoring ensure your website remains secure and runs smoothly."
  },
  {
    question: "How much is the website maintenance cost in India?",
    answer: "The website maintenance cost in India is usually more affordable compared to global rates. Basic plans for small business websites can start as low as ₹1,500 – ₹5,000 per month, while advanced maintenance services for eCommerce or enterprise websites may range between ₹10,000 – ₹25,000 per month. At Eratec Solution, we provide customized website maintenance packages in India to fit your business needs and budget."
  },
  {
    question: "How often will my website be updated?",
    answer: "We offer flexible plans — from weekly and monthly updates to real-time monitoring and on-demand support. Update frequency depends on your site’s complexity, traffic, and business needs."
  },
  {
    question: "Do you support websites not originally built by your team?",
    answer: "Yes, we can take over the maintenance of most websites even if we didn’t build them — after a quick audit to understand your tech stack, security, and structure. We ensure a smooth transition before ongoing support begins."
  },
  {
    question: "Can I request changes or new features as part of maintenance?",
    answer: "Absolutely. Whether it’s adding new content, updating forms, or implementing features, we offer flexible support hours or retainers to accommodate your evolving needs without starting from scratch."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="col text-center py-5 mt-5" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div className="accordion__panel faq-ans">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
